import { Route, Routes, useLocation } from 'react-router-dom';
import { Suspense } from 'react';
import Background from './AppStyles';
import AnnouncementBar from './components/common/AnnouncementBar';
import { PageLoader } from './components/common/PageLoader';
import TradePage from './pages/TradePage';
import HomePage from './pages/HomePage';
import ModalWrap from './providers/ModalWrap';
import AuthWrap from './providers/AuthWrap';
import SnackbarWrap from './wrapper/SnackbarWrap';
import ExoticPage from './pages/ExoticPage';
import RestPage from './pages/RestPage';

const AppContent = () => {
  const path = useLocation().pathname;
  if (path.includes("index")) {
    window.location.href = "/";
  }
  return (
    <Background>
      <SnackbarWrap>
        {/*
          Sibling of `.root`, not a child: `.root` is `display: flex; flex-direction:
          row`, so a child became a full-height column beside the chart. Background's
          grid already reserves a 'Notification' row for exactly this, which the bar
          claims via `.announcement-slot`.
        */}
        <AnnouncementBar />
        <div className="relative root w-[100vw] pb-[5px] ">
          <Routes>
            <Route
              path="/"
              element={
                <HomePage />
              }
            />
            <Route
              path="/ex/:market"
              element={
                <Suspense fallback={<PageLoader />}>
                  <ExoticPage />
                </Suspense>
              }
            />
            <Route
              path="/:market"
              element={
                <Suspense fallback={<PageLoader />}>
                  <TradePage />
                </Suspense>
              }
            />
            {/* Rest routs, redirect to */}
            <Route
              path="*"
              element={
                <RestPage />
              }
            />
          </Routes>
        </div>
      </SnackbarWrap>
    </Background>
  );
};

const App = () => {

  return (
    <>
      <AuthWrap />
      <ModalWrap />
      <AppContent />
    </>
  );
};

export default App;
